export function toUtcStartIso(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  return `${yyyyMmDd}T00:00:00.000Z`;
}

export function toUtcEndExclusiveIso(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const startIso = toUtcStartIso(yyyyMmDd);
  if (!startIso) return null;
  const d = new Date(startIso);
  if (Number.isNaN(d.getTime())) return null;
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString();
}
